export type TrackingValue = string | number | boolean | null | undefined;

export const toStr = (value: TrackingValue): string | undefined => {
    if (value === null || value === undefined || value === '') {
        return undefined;
    }
    return String(value);
};

export const toRequiredStr = (value: TrackingValue, fallback = ''): string =>
    toStr(value) ?? fallback;

export const toNumericStr = (value: TrackingValue): string =>
    (toStr(value) ?? '').replace(/\D/g, '');

export const compact = <T extends object>(obj: T): T =>
    Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined)) as T;
